import { BaseHttpError, useServices } from 'core/services';
import { calendarKeys } from 'core/utils/query-key-factory';
import { useQuery } from '@tanstack/react-query';

type ExportCalendarSelectData = {
	token: string;
	downloadUrl: string;
};

export const useGetExportCalendarToken = (calendarId: string) => {
	const { api } = useServices();

	return useQuery<string, BaseHttpError, ExportCalendarSelectData>({
		queryKey: calendarKeys.exportToken(calendarId),
		queryFn: () =>
			api
				.getExportToken(calendarId)
				.then(response => response.data.token),
		enabled: !!calendarId,
		select: token => {
			return {
				token,
				downloadUrl: `${api.client.defaults.baseURL}calendar/${calendarId}/export/${token}`,
			};
		},
	});
};
